import { render, staticRenderFns } from "./AffiliateTermsTab.vue?vue&type=template&id=0f25cfae&scoped=true&"
import script from "./AffiliateTermsTab.vue?vue&type=script&lang=js&"
export * from "./AffiliateTermsTab.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateTermsTab.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AffiliateTermsTab.vue?vue&type=style&index=1&id=0f25cfae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f25cfae",
  null
  
)

export default component.exports